import axios from "axios";
import Cookies from "js-cookie";

// export const API_URL = "http://localhost:5000";
export const API_URL = "https://api.ambeworlds.com";

const api = axios.create({
  //   baseURL: process.env.REACT_APP_API_URL,
  // baseURL: "https://jskapi.onrender.com/api",
  baseURL: API_URL,
  // baseURL: "http://localhost:5000",
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to attach the token
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default api;
